import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  event: {
    data: [],
    meta: {
      total: 0,
    },
  },

  mainEvent: [],
};

// TODO: fetch all the event
export const fetchEvent = createAsyncThunk(
  "fetchEvent/event",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`event`, {
        params: {
          limit,
          page: page + 1,
  
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.data.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create event
export const createEvent = createAsyncThunk(
  "createEvent/event",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`event`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update event
export const updateEvent = createAsyncThunk(
  "updateEvent/event",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`event/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete event
export const deleteEvent = createAsyncThunk(
  "deleteEvent/event",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`event/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get event
    builder.addCase(fetchEvent.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchEvent.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.event = action.payload;
    });

    builder.addCase(fetchEvent.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create event
    builder.addCase(createEvent.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createEvent.fulfilled, (state, action) => {
      state.isLoading = false;
      state.event.data = [action.payload.data, ...state.event.data];
      state.event.meta.total = state.event.meta.total + 1;
      action.payload.enqueueSnackbar("Event is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
      action.payload.setActiveTab(action.payload.activeTab);
    });

    builder.addCase(createEvent.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update event
    builder.addCase(updateEvent.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateEvent.fulfilled, (state, action) => {
      state.isLoading = false;
      state.event.data = state.event.data.map((event) => {
        if (event.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return event;
        }
      });
      action.payload.enqueueSnackbar("Event is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateEvent.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete event
    builder.addCase(deleteEvent.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteEvent.fulfilled, (state, action) => {
      state.isLoading = false;
      state.event.data = state.event.data.filter(
        (event) => event.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Event is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteEvent.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default eventSlice.reducer;

export const { resetLoadings } = eventSlice.actions;
